import React from 'react'

// const debug = false
const debug = "FieldColor_PickerValueNotEmpty"

export default function FieldColor_PickerValueNotEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    const option        = props.field._getOption(props.value)

    const classes       = Classes("ui5-field-picker", "size-"+props.size, props.className)
    const colorClasses  = Classes("ui5-color-picker", "gd-c-"+option.value, {
        's-30': props.size === '30'
    })

    return (
        <div className={classes} onClick={props.onClick}>
            <div className={colorClasses}/>
            {props.children}
        </div>
    )
}
